import { Component } from '@angular/core'
import { RushMainService } from '@rush-shared/services/rush-main.service'
import { LoggerTabsComponent } from '../logger-tabs/logger-tabs.component'
import { TabsConst } from '@rush-shared/constants'

@Component({
  selector: 'app-logger-main',
  standalone: true,
  imports: [LoggerTabsComponent],
  templateUrl: './logger-main.component.html',
  styleUrl: './logger-main.component.sass',
})
export class LoggerMainComponent {
  constructor(private _rushMainService: RushMainService) {}

  isTabSelected() {
    return TabsConst.some((i) => i.name === this._rushMainService.activeTab$.value.name)
  }
}
